import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tippy from '@tippyjs/react';
import Menu from '../menu/Menu';
import MenuItem from '../menu/MenuItem';
import PlaybackRateMenuButton from "./PlaybackRateMenuButton";

class SettingMenu extends Component {
    constructor(props, context) {
        super(props, context);
        this.handleSelectQualityItem = this.handleSelectQualityItem.bind(this);
        this.handleSelectPlaybackRateItem = this.handleSelectPlaybackRateItem.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            active: false,
            activateQualityIndex: 0,
            activatePlaybackRateIndex: 0,
        };
    }

    componentDidMount() {
        const {
            activeTrack,
            tracks,
            rates,
            playbackRate,
        } = this.props;
        if (tracks && tracks.length > 1) {
            const activeTrackLabel = tracks.filter(item => item.id === activeTrack)[0];
            this.setState({
                activateQualityIndex: activeTrackLabel.id === -1 ? 0 : activeTrackLabel.id,
            });
        }
        this.setState({
            activatePlaybackRateIndex: rates.indexOf(playbackRate) || 0,
        });
    }

    handleSelectQualityItem(index) {
        const { tracks, actions } = this.props;
        if (index >= -1 && index < tracks.length) {
            actions.handleTrackChange(index - 1);
        }
    }

    handleSelectPlaybackRateItem(index) {
        const { rates, actions } = this.props;
        if (index >= 0 && index < rates.length) {
            actions.changeRate(rates[index]);
        }
    }

    handleClick() {
        this.setState({
            active: !this.state.active,
        });
    }

    render() {
        const {
            className,
            inline,
            realActiveTrack,
            switchingTrack,
            tracks,
            rates,
            isLive,
            activeTrack,
            playbackRate,
        } = this.props;
        const { active } = this.state;
        let qualityItems,
            realActiveTrackLabel,
            activateQualityIndex,
            activatePlaybackRateIndex;
        if (tracks && tracks.length > 1) {
            const activeTrackLabel = tracks.filter(item => item.id === activeTrack)[0];
            activateQualityIndex = activeTrackLabel.id === -1 ? 0 : (activeTrackLabel.id + 1);
            realActiveTrackLabel = tracks.filter(item => item.id === realActiveTrack)[0];
            qualityItems = tracks.map((item, index) => (
                {
                    label: item.label,
                    value: index,
                }
            ));
        }
        const playbackRateItems = rates.map(rate => (
            {
                label: `${rate}x`,
                value: rate,
            }
        ));
        activatePlaybackRateIndex = rates.indexOf(playbackRate) || 0;

        return (
            <Tippy
                interactive={true}
                animation="shift-away"
                arrow={false}
                interactiveBorder={16}
                offset={[0, 0]}
                content={
                    <div>
                        {!isLive && playbackRateItems &&
                            <div className="video-react-settings-wrapper">
                                <div className="video-react-settings-title">سرعت پخش</div>
                                <Menu className="video-react-settings-content">
                                    {playbackRateItems.map((item, i) => (
                                        <MenuItem
                                            item={item}
                                            index={i}
                                            onSelectItem={this.handleSelectPlaybackRateItem}
                                            activateIndex={activatePlaybackRateIndex}
                                            key={`playback-rate-item-${i++}`}
                                        />
                                    ))}
                                </Menu>
                            </div>
                        }
                        {tracks && tracks.length > 1 && qualityItems &&
                            <div className="video-react-settings-wrapper">
                                <div className="video-react-settings-title">کیفیت پخش</div>
                                <Menu className="video-react-settings-content">
                                    {qualityItems.map((item, i) => (
                                        <MenuItem
                                            item={item}
                                            index={i}
                                            onSelectItem={this.handleSelectQualityItem}
                                            activateIndex={activateQualityIndex}
                                            key={`quality-item-${i++}`}
                                        />
                                    ))}
                                </Menu>
                            </div>
                        }
                    </div>
                }>
                <div
                    className={classNames(className, {
                        'video-react-settings-control': true,
                        'video-react-control': true,
                        'video-react-button': true,
                        'video-react-icon-settings': true,
                        'video-react-icon-spin': switchingTrack,
                        'video-react-menu-button-inline': !!inline,
                        'video-react-menu-button-popup': !inline,
                        'video-react-menu-button-active': active,
                    }, 'video-react-control video-react-button video-react-menu-button')}
                    role="button"
                    tabIndex="0"
                    onClick={this.handleClick}
                    ref={(c) => {
                        this.menuButton = c;
                    }}>
                    <div className="video-react-settings-label">
                        {playbackRate && Number(playbackRate) !== 1 &&
                        <div className="video-react-playback-rate-value">{playbackRate}x</div>
                        }
                        {realActiveTrackLabel &&
                        <div className='video-react-active-track-label'>
                            {realActiveTrackLabel.label}
                        </div>
                        }
                    </div>
                </div>
            </Tippy>
        );
    }
}

SettingMenu.propTypes = {
    activeTrack: PropTypes.number,
    tracks: PropTypes.array,
    rates: PropTypes.array,
    onSetTrack: PropTypes.func,
};
SettingMenu.defaultProps = {
    rates: [0.5, 0.75, 1, 1.25, 1.5],
};
SettingMenu.displayName = 'PlaybackRateMenuButton';
export default SettingMenu;
